import React, { createContext, useEffect, useState } from "react"

export const CommunityProjectContext = createContext()

export const CommunityProjectContextProvider = ({ children }) => {
  var [listReloadCounter, setListReloadCounter] = React.useState(0)
  var [successData, setSuccessData] = React.useState(null)
  var [isNowContributor, setIsNowContributor] = React.useState(false)

  return (
    <CommunityProjectContext.Provider
      value={{
        listReloadCounter,
        successData,
        setSuccessData,
        isNowContributor,
        setIsNowContributor,
      }}
    >
      {children}
    </CommunityProjectContext.Provider>
  )
}
